export const LOCAL_STORAGE_KEYS = {
  PRIVATE_MODE: 'PRIVATE_MODE',
} as const;
